// extracted by mini-css-extract-plugin
module.exports =  {"requestsIndicatorContainer":"_requestsIndicatorContainer--2pTC9","small":"_small--2tJNH","large":"_large--2ZfIH","numAssignedSlotsLabel":"_numAssignedSlotsLabel--2hOr9"};